import Entity from '../../schema/Entity';
import EntityTypeNames from '../../schema/innerSchema/EntityTypeNames';
import setBasicEntityData from './SetBasicEntityData';
import setDiningEntityData from './setDiningEntityData';
import setEventEntityData from './setEventEntityData';
import setFlightEntityData from './setFlightEntityData';
import setInvoiceEntityData from './setInvoiceEntityData';
import setLodgingReservationEntityData from './setLodgingReservationEntityData';
import setParcelDeliveryEntityData from './setParcelDeliveryEntityData';
import setRentalCarEntityData from './setRentalCarEntityData';
import setServiceReservationEntityData from './setServiceReservationEntityData';

/**
 * create Entity item based on the type
 */
export default function tryCreateEntityItem(
    entityBlob: any,
    isInvoiceEnabled?: boolean,
    isServiceReservationEnabled?: boolean,
    useEntityId?: boolean
): Entity {
    if (entityBlob) {
        // create new Entity with basic data
        let entityItem = setBasicEntityData(entityBlob, useEntityId);
        // check for entity type and parse data accordingly
        if (entityItem) {
            let entityType: string = entityBlob['@type'];
            switch (entityType) {
                case EntityTypeNames.FlightReservation: {
                    entityItem = setFlightEntityData(entityItem, entityBlob);
                    break;
                }
                case EntityTypeNames.RentalCarReservation: {
                    entityItem = setRentalCarEntityData(entityItem, entityBlob);
                    break;
                }
                case EntityTypeNames.ParcelDelivery: {
                    entityItem = setParcelDeliveryEntityData(entityItem, entityBlob);
                    break;
                }
                case EntityTypeNames.LodgingReservation: {
                    entityItem = setLodgingReservationEntityData(entityItem, entityBlob);
                    break;
                }
                case EntityTypeNames.FoodReservation: {
                    entityItem = setDiningEntityData(entityItem, entityBlob);
                    break;
                }
                case EntityTypeNames.EventReservation: {
                    entityItem = setEventEntityData(entityItem, entityBlob);
                    break;
                }
                case EntityTypeNames.Invoice: {
                    entityItem = isInvoiceEnabled
                        ? setInvoiceEntityData(entityItem, entityBlob)
                        : null;
                    break;
                }
                case EntityTypeNames.ServiceReservation: {
                    entityItem = isServiceReservationEnabled
                        ? setServiceReservationEntityData(entityItem, entityBlob)
                        : null;
                    break;
                }
                default:
                    return null;
            }
            return entityItem as Entity;
        }
    }
    return null;
}
